const UnreadSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M9.5 12H2L1.9985 4.453L7.7155 8.411C7.7991 8.46884 7.89834 8.49983 8 8.49983C8.10166 8.49983 8.2009 8.46884 8.2845 8.411L14 4.455V9H15V4C14.9996 3.73491 14.8941 3.48078 14.7067 3.29333C14.5192 3.10588 14.2651 3.0004 14 3H2C1.73478 3 1.48043 3.10536 1.29289 3.29289C1.10536 3.48043 1 3.73478 1 4V12C1.0004 12.2651 1.10588 12.5192 1.29333 12.7067C1.48078 12.8941 1.73491 12.9996 2 13H9.5V12ZM12.8995 4L8 7.392L3.1005 4H12.8995Z"
        fill="#333333"
      />
      <path
        d="M13 14C14.1046 14 15 13.1046 15 12C15 10.8954 14.1046 10 13 10C11.8954 10 11 10.8954 11 12C11 13.1046 11.8954 14 13 14Z"
        fill="#333333"
      />
    </svg>
  );
};

export default UnreadSvg;
